import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Product } from '../../../common/models/Product.Model'
import { UserLogin } from '../../../common/models/UserLogin.Model';
import { SettingsService } from '../../../../core/settings/settings.service';
import { TaxService } from '../../tax.service';

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.scss']
})
export class ProductDetailComponent implements OnInit {

  productCode: string = '';
  product: Product = new Product();
  user: UserLogin;

  constructor(
    private settings: SettingsService,
    private taxServices: TaxService,
    private url: ActivatedRoute,
    private router: Router
  ) {
    // Obtenemos el ID de la URL
    const idParam = this.url.snapshot.paramMap.get('id');
    this.productCode = idParam ? idParam.toString() : '';
    this.user = this.settings.getUser();
  }

  ngOnInit(): void {
    if (this.productCode) {
      this.loadProduct();
    }
  }

  async loadProduct() {
    try {
      const resp = await this.taxServices.getProductByCode(this.user.Org, this.productCode).toPromise();
      if (resp) {
        // Formateo de código a 4 dígitos
        resp.ProductCode = resp.ProductCode ? resp.ProductCode.toString().padStart(4, '0') : '';
        
        // Evitar que el barcode falle si viene vacío
        if (!resp.Codebar) resp.Codebar = '000000000000';
        
        this.product = resp;
      }
    } catch (error) {
      console.error("Error cargando producto:", error);
    }
  }

  btnCancelOnClick() {
    window.close();
  }
}